namespace Gordic.Adm.WebControls.OrganizacniJednotka {

    export function openSeznamOrganizacniJednotkaDenikSsl(data: any) {
		$.content().navigate("Gordic.Adm.WebControls.SeznamOrganizacniJednotkaDenikSsl", { ixs_orj: data.ixs_orj })
	}
}